import React, {useEffect, useState} from 'react';
import { NavLink } from 'react-router-dom';

import { ClipboardCopyIcon, DocumentTextIcon, FireIcon } from '@heroicons/react/outline';

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

const DailyStats = ({allUserMsg, copiedMsg, likedMsg}) => {

    const [ dailyProjects, setDailyProjects ] = useState()
    const [ dailyCopied, setDailyCopied ] = useState() 
    const [ dailyLiked, setDailyLiked ] = useState() 

    const navlinkStyle = {textDecoration: 'none'}

    var all = dailyProjects ? dailyProjects?.length : 0;
    var copied = (dailyProjects && dailyCopied) ? ((dailyCopied?.length / dailyProjects?.length)*100) : 0;
    var liked = (dailyProjects && dailyLiked) ? ((dailyLiked?.length / dailyProjects?.length)*100) :0;

    useEffect(() => {
        const DailyProjects = () => {
            var arr = [];
            var arrCopied = [];
            var arrLiked = [];
            allUserMsg?.map(projects =>{
                if(projects.ContentCreated){
                    projects.ContentCreated.map(project => {
                        const date1 = new Date(project.CreatedAt.toDate())
                        const date2 = new Date();
                        const diffTime = Math.abs(date2 - date1);
                        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
            
                        if(diffDays < 2){
                            arr.push(project)
                        }
                        return arr
                    })
                return projects
            }else { 
                return null
            }
            })
            copiedMsg?.map(project =>{
                // console.log(project)
                if(project.createdAt){
                const date1 = new Date(project.createdAt.toDate())
                // console.log(date1)
                const date2 = new Date();
                const diffTime = Math.abs(date2 - date1);
                const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
                
                //treba u staroj da se popravi(dodati novi contentCopy niz ili novu kolekciju) jer povlaci stari datum 
                if(diffDays < 2){
                    arrCopied.push(project)
                }
                return arrCopied
            }else { 
                return null
            }
            })
            likedMsg?.map(project =>{
                if(project.CreatedAt){
                const date1 = new Date(project.CreatedAt.toDate())
                const date2 = new Date();
                const diffTime = Math.abs(date2 - date1);
                const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
                
                if(diffDays < 2){
                    arrLiked.push(project)
                }
                return arrLiked
            }else { 
                return null
            }
            })
            setDailyProjects(arr)
            setDailyCopied(arrCopied)
            setDailyLiked(arrLiked)
        }

       DailyProjects()
    }, [allUserMsg, copiedMsg, likedMsg])

    const stats = [
        { name: 'Total Messages Today', stat:  all, icon: DocumentTextIcon, href: '/allDailyProjects'},
        { name: 'Copied Messages', stat:  copied.toFixed(2) === 'NaN' ? (0 + ' %') : copied.toFixed(2) + ' %', icon: ClipboardCopyIcon, href: '/copiedDaily', length: dailyCopied?.length },
        { name: 'Fire Messages', stat: liked.toFixed(2) === 'NaN' ? (0 + ' %') : liked.toFixed(2) + ' %', icon: FireIcon, href: '/likedDaily', length: dailyLiked?.length},
    ]

    return (
        <div>
            <h3 className="text-lg leading-6 font-medium text-gray-900">Daily Messages Created</h3>
            <dl className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {stats.map((item) => (
                <div
                key={item.name}
                className="relative bg-white pt-5 px-4 pb-12 sm:pt-6 sm:px-6 shadow rounded-lg overflow-hidden"
                >
                <dt>
                    <div className="absolute bg-yellow-500 rounded-md p-3">
                    <item.icon className="h-6 w-6 text-white" aria-hidden="true" />
                    </div>
                    <p className="ml-16 text-sm font-medium text-gray-500 truncate">{item.name}</p>
                </dt>
                <dd className="ml-16 pb-6 items-baseline sm:pb-7">
                    <p className="text-2xl font-semibold text-gray-900">{item.stat}</p>
                    {item.length > 0 ?
                    <div className="font-medium text-gray-600 text-right my-2">
                        Amount: {item.length}
                    </div>
                    :
                    null }
                    <div className="absolute bottom-0 inset-x-0 bg-gray-50 px-4 py-4 sm:px-6">
                    <div className="text-sm">
                        <NavLink
                        style={navlinkStyle}
                        key={item.name}
                        exact
                        to={item.href}
                        className={classNames(
                        item.current ? 'bg-gray-900 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white',
                        'group flex items-center px-2 py-2 text-base font-medium rounded-md'
                        )}
                        >
                            <item.icon className="mr-3 h-6 w-6 text-yellow-300" aria-hidden="true" />
                            View all
                        </NavLink>
                    </div>
                    </div>
                </dd>
                </div>
            ))}
            </dl>
        </div>
    )
}

export default DailyStats